import * as React from 'react';
import { connect } from 'react-redux';
import { SortableContainer, arrayMove } from 'react-sortable-hoc';

import NotifyHOC from '../../../../../HOC/Notifications';

import OptionCardSortable from './OptionCardSortable';
import { IApplicationState } from '../../../../../reducers';
import { Project } from '@nexxt/common/types';
import MediaLibraryAddModal from '../../../../libraries/mediaLibrary/MediaLibraryAddModal';
import { OPTION_TYPES } from '@nexxt/common/types';

const EmptyList = [];

export interface IOptionProps {
    showRandomize?: boolean;
    isTypeScale?: boolean;
    languages: any[];
    selectedOptionType: OPTION_TYPES;
    handleOptionFields: (
        data: Array<IOptionFields>,
        deletedOptionIDs?: number[]
    ) => void;
    notify: (
        msg: string,
        type: string,
        options?: Record<string, unknown>,
        callback?: () => unknown
    ) => any;
    currentProject: Project;
    isRichText: boolean;
    options: any[];
    optionsError: any;
    editEnabled: boolean;
}

export interface IOptionFields {
    id?: number;
    label: string;
    value: number;
    mediaURL: string;
    texts: Array<any>;
    randomizeOption: boolean;
}

interface IOptionCardTextState {
    // optionFields: Array<IOptionFields>;
    isMediaLibraryOpen: boolean;
    currentIndex: number;
}

class Option extends React.Component<IOptionProps, IOptionCardTextState> {
    constructor(props) {
        super(props);
        this.state = {
            isMediaLibraryOpen: false,
            currentIndex: null
        };
    }

    handleChange = (index, evt) => {
        const optionFields = [...(this.props.options || [])];
        const newOptionField = optionFields.map((field, sindex) => {
            if (index !== sindex) return field;
            return { ...field, [evt.target.name]: evt.target.value };
        });

        this.props.handleOptionFields(newOptionField);
    };

    // @todo: work in progress
    handleRichText = (index, textIndex, text, language) => {
        const optionFields = (this.props.options || []).map((o) => {
            return {
                ...o,
                texts: [...o.texts.map((t) => ({ ...t }))]
            };
        });
        if (textIndex > -1) {
            optionFields[index].texts[textIndex].text = text;
        } else {
            optionFields[index].texts.push({ language, text });
        }
        this.props.handleOptionFields(optionFields);
    };

    handleToggleValueChange = (index, keyName, value) => {
        const optionFields = [...(this.props.options || [])];
        const newOptionField = optionFields.map((field, sindex) => {
            if (index !== sindex) return field;
            return { ...field, [keyName]: value };
        });
        this.props.handleOptionFields(newOptionField);
    };

    handleLanguageChange = (index, textIndex, evt, language) => {
        const optionFields = (this.props.options || []).map((o) => {
            return {
                ...o,
                texts: [...o.texts.map((t) => ({ ...t }))]
            };
        });
        if (textIndex > -1) {
            optionFields[index].texts[textIndex].text = evt.target.value;
        } else {
            optionFields[index].texts.push({
                language,
                text: evt.target.value
            });
        }
        this.props.handleOptionFields(optionFields);
    };

    moveCard = (dragIndex: number, hoverIndex: number) => {
        console.log('move', dragIndex, hoverIndex);
        const optionFields = [...(this.props.options || [])];
        const dragItem = { ...optionFields[dragIndex] };
        optionFields.splice(dragIndex, 1);
        optionFields.splice(hoverIndex, 0, dragItem);
        this.props.handleOptionFields(optionFields);
    };

    onSortEnd = (oldIndex: number, newIndex: number) => {
        console.log('move', oldIndex, newIndex);
        const optionFields = [...(this.props.options || [])];
        arrayMove(optionFields, oldIndex, newIndex);
        this.props.handleOptionFields(optionFields);
    };

    onOptionCreationCompleted = (evt) => {
        evt.preventDefault();
    };

    handleRemoveOptionField = (index) => {
        if (index >= 0) {
            const optionFields = [...(this.props.options || [])];
            const deletedId = optionFields[index].optionID;
            optionFields.splice(index, 1);
            this.props.handleOptionFields(
                optionFields,
                deletedId ? [deletedId] : []
            );
        }
    };

    setSelectedMedia = (newMedia) => {
        const optionFields = [...(this.props.options || [])];
        const newOptionField = optionFields.map((field, sindex) => {
            if (this.state.currentIndex !== sindex) return field;
            return { ...field, mediaURL: newMedia.src };
        });

        this.props.handleOptionFields(newOptionField);

        this.closeModal();
    };

    closeModal = () => {
        this.setState({
            isMediaLibraryOpen: false,
            currentIndex: null
        });
    };

    openMediaLibrary = (index) => {
        this.setState({
            isMediaLibraryOpen: true,
            currentIndex: index
        });
    };

    render() {
        const optionFields = this.props.options || EmptyList;
        return (
            <React.Fragment>
                <form onSubmit={this.onOptionCreationCompleted}>
                    {this.state.isMediaLibraryOpen && (
                        <MediaLibraryAddModal
                            isOpen={this.state.isMediaLibraryOpen}
                            setSelectedMedia={this.setSelectedMedia}
                            notify={this.props.notify}
                            onCancel={this.closeModal}
                            onClose={this.closeModal}
                            showMediaLibrary={true}
                            type={'image'}
                        />
                    )}

                    {optionFields.map((field, index) => {
                        return (
                            <OptionCardSortable
                                key={
                                    'OptionCard-' +
                                    (field.optionID
                                        ? field.optionID
                                        : index + 'new')
                                }
                                option={field as IOptionFields}
                                isTypeScale={false} // this.props.isTypeScale
                                optionsError={this.props.optionsError}
                                optionIndex={index}
                                index={field.id || index}
                                currentProject={this.props.currentProject}
                                languages={this.props.languages}
                                isRichText={this.props.isRichText}
                                showRandomize={this.props.showRandomize}
                                selectedOptionType={
                                    this.props.selectedOptionType
                                }
                                handleChange={this.handleChange}
                                handleToggleValueChange={
                                    this.handleToggleValueChange
                                }
                                handleLanguageChange={this.handleLanguageChange}
                                handleRichText={this.handleRichText}
                                handleRemoveOptionField={
                                    this.handleRemoveOptionField
                                }
                                editEnabled={this.props.editEnabled}
                                openMediaLibrary={this.openMediaLibrary}
                                onSortEnd={this.onSortEnd}
                                useDragHandle={true}
                            />
                        );
                    })}
                </form>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject, editEnabled }
    } = store;
    return {
        currentProject,
        editEnabled: editEnabled['question']
    };
};

const SortableOptionContainer = SortableContainer(Option);

class WrapperClass extends React.Component<IOptionProps, any> {
    onSortEnd = ({ oldIndex, newIndex }) => {
        console.log('move', oldIndex, newIndex);
        const optionFields = [...(this.props.options || [])];
        this.props.handleOptionFields(
            arrayMove(optionFields, oldIndex, newIndex)
        );
    };
    render() {
        return (
            <SortableOptionContainer
                {...this.props}
                onSortEnd={this.onSortEnd}
                useDragHandle={true}
            />
        );
    }
}

export default NotifyHOC(connect(mapStateToProps, null)(WrapperClass));
